export class BithidePaymentApiConverter {
  convertCurrencyRate = data => {
    return ({
      rate: data?.rate,
      agentCommission: data?.agent_comission,
    })
  }

  convertDepositInitData = data => {
    return ({
      id: data.id,
      replenishmentAddress: data.replenishment_address,
      status: data.status,
      fromCurrency: data.from_currency,
      fromCurrencyAmount: data.from_currency_amount,
      toCurrency: data.to_currency,
      toCurrencyAmount: data.to_currency_amount,
      createdAt: new Date(data.created_at),
      validUntil: new Date(data.valid_until),
      commissionPercent: data.comission_percent,
    })
  }

  convertDepositInfo = data => ({
    id: data.id,
    replenishmentAddress: data.replenishment_address,
    status: data.status,
    clientExternalId: data.client_external_id,
    fromCurrency: data.from_currency,
    fromCurrencyAmount: data.from_currency_amount,
    toCurrency: data.to_currency,
    toCurrencyAmount: data.to_currency_amount,
    createdAt: new Date(data.created_at),
    validUntil: new Date(data.valid_until),
    paidAt: new Date(data.paid_at),
    blockchainTransactionId: data.blockchain_transaction_id,
  })

  convertDepositHistory = data => ({
    deposits: data?.deposits?.map(item => ({
      id: item.id,
      replenishmentAddress: item.replenishment_address,
      status: item.status,
      fromCurrency: item.from_currency,
      fromCurrencyAmount: item.from_currency_amount,
      toCurrency: item.to_currency,
      clientExternalId: item.client_external_id,
      toCurrencyAmount: item.to_currency_amount,
      createdAt: new Date(item.created_at),
      validUntil: new Date(item.valid_until),
      paidAt: new Date(item.paid_at),
      blockchainTransactionId: item.blockchain_transaction_id,
    })) || [],
    count: data?.count,
  })
}
